export default [
  {
    path: "/tipos-instrumentos",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "tipos_instrumentos_list",
        path: "",
        component: () => import("./pages/List"),
        meta: {
          breadcrumbs: [
            { label: "tipos_instrumentos", to: "tipos_instrumentos_list" }
          ],
          permission: "tipo_instrumento:view",
          title: "tipos_instrumentos"
        }
      },
      {
        name: "tipos_instrumentos_create",
        path: "novo",
        component: () => import("./pages/Create"),
        meta: {
          breadcrumbs: [
            { label: "tipos_instrumentos", to: "tipos_instrumentos_list" }
          ],
          permission: "tipo_instrumento:create",
          title: "tipos_instrumentos - Cadastro"
        }
      },
      {
        name: "tipos_instrumentos_edit",
        path: "editar/:id",
        component: () => import("./pages/Edit"),
        meta: {
          breadcrumbs: [
            { label: "tipos_instrumentos", to: "tipos_instrumentos_list" }
          ],
          permission: "tipo_instrumento:edit",
          title: "tipos_instrumentos - Edição"
        }
      }
    ]
  }
];
